import React from 'react';
import i18n from 'i18next';

// components
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import {
    headerTunables,
    opacityTunables,
    overflowTunables,
} from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    gridTunables,
    legendTunables,
    metaInfoTunables,
    xAxisTunables,
    yAxisTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import ActionSliderGroup from 'components/_UI/Forms/Actions/ActionSliderGroup';

// types
import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';

// helpers
import { widgetDimIsDate } from 'utils/Widget/WidgetUtils';

export const HyperSpaceBarChartWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => {
    const isTimeDim: boolean = widgetDimIsDate(widget);
    return [
        {
            props: {
                label: i18n.t('Bar Chart'),
                startOpen: true,
            } as CollapseProps,
            children: [
                ...headerTunables(widget),
                opacityTunables(widget),
                overflowTunables(widget),
                gridTunables(widget),
                <ActionSliderGroup
                    key='barHeight'
                    label={i18n.t('Bar Height')}
                    showValue
                    option={widget.options}
                    value='barHeight'
                    min={25}
                    max={150}
                />,
            ],
        },
        metaInfoTunables({ widget, color: true, image: true }),
        xAxisTunables({ widget, mergedTheme, axisIsDim: false }),
        yAxisTunables({ widget, format: isTimeDim ? true : false, mergedTheme }),
        widget.options.compareMode ? legendTunables(widget, { metric: false }) : null,
    ];
};
